// extracted by mini-css-extract-plugin
export var nav = "SideNav-module--nav--QANM2";
export var active = "SideNav-module--active--3Osj1";